import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ARCHIVE_SZLT,
  ASSIGN_SZLT_BY_ID,
  CREATE_SZLT,
  DELETE_SZLT,
  EDIT_SZLT_BY_ID,
  LOAD_SZLT_BY_ID,
  LOAD_SZLT_LIST,
  ANNULMENT_SZLT,
  UNARCHIVE_SZLT,
  LOAD_CARRIER_LIST,
  CREATE_CARRIER,
  EDIT_CARRIER_BY_ID,
  LOAD_CARRIER_BY_ID,
  ARCHIVE_CARRIER,
  UNARCHIVE_CARRIER,
  DELETE_CARRIER,
  ANNULMENT_CARRIER,
  LOAD_VEHICLES_LIST,
  CREATE_VEHICLES,
  EDIT_VEHICLES_BY_ID,
  LOAD_VEHICLES_BY_ID,
  ARCHIVE_VEHICLES,
  UNARCHIVE_VEHICLES,
  DELETE_VEHICLES,
  ANNULMENT_VEHICLES,
  LOAD_REGISTRY_HISTORY_LIST,
  LOAD_REGISTRY_EXPORT_LIST,
  LOAD_REGISTRY_SMEV_CHECK_LIST,
  IMPORT_VEHICLES,
  IMPORT_CARRIER,
  EXPORT_CARRIER,
  EXPORT_VEHICLES,
  IMPORT_SZLT,
  EXPORT_SZLT,
  LOAD_SMEV_CHECK_CARRIER_LIST,
  LOAD_SMEV_CHECK_SZLT_LIST,
  LOAD_SMEV_CHECK_VEHICLE_LIST,
  SMEV_CHECK_ALL_CARRIER,
  SMEV_CHECK_ALL_SZLT,
  SMEV_CHECK_ALL_VEHICLES,
  EXTRACT_CARRIER,
  EXTRACT_SZLT,
  EXTRACT_VEHICLES,
  CARRIER_FIELDS_VALIDATION,
  VEHICLE_FIELDS_VALIDATION,
  SZLT_FIELDS_VALIDATION,
  LOAD_RELATION_CARRIER_VEHICLE_LIST,
  LOAD_RELATION_CARRIER_SZLT_LIST,
  LOAD_RELATION_VEHICLE_SZLT_LIST,
  LOAD_SZLT_LIST_MODAL,
  LOAD_CARRIER_LIST_MODAL,
  LOAD_VEHICLES_LIST_MODAL,
  IMPORT_OSAGO,
  EXPORT_OSAGO, BATCH_COMMAND_VEHICLE, BATCH_COMMAND_CARRIER, BATCH_COMMAND_SZLT,
} from './actions';
import { REGION_REGISTRY_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducer,
  createLoadListReducerWithBegin, createLoadParameterReducer,
  createOperationStateReducer, updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  szltListMeta: {},
  loadingSzltList: false,
  szltList: [],
  loadingCreateSZLT: false,
  loadingEditSZLT: false,
  currentSZLT: {},
  loadingCurrentSZLT: false,
  loadingArchiveSZLT: false,
  loadingUnarchiveSZLT: false,
  loadingDeleteSZLT: false,
  loadingAnnulmentSZLT: false,
  carrierListMeta: {},
  loadingCarrierList: false,
  carrierList: [],
  loadingCreateCarrier: false,
  loadingEditCarrier: false,
  currentCarrier: {},
  loadingCurrentCarrier: false,
  loadingArchiveCarrier: false,
  loadingUnarchiveCarrier: false,
  loadingDeleteCarrier: false,
  loadingAnnulmentCarrier: false,
  vehiclesListMeta: {},
  loadingVehiclesList: false,
  vehiclesList: [],
  loadingCreateVehicles: false,
  loadingEditVehicles: false,
  currentVehicles: {},
  loadingCurrentVehicles: false,
  loadingArchiveVehicles: false,
  loadingUnarchiveVehicles: false,
  loadingDeleteVehicles: false,
  loadingAnnulmentVehicles: false,
  loadingRegistryHistoryList: false,
  registryHistoryList: [],
  registryHistoryListMeta: {},
  registryExportList: [],
  registryExportListMeta: {},
  loadingExportHistory: false,
  registrySmevCheckList: [],
  registrySmevCheckListMeta: {},
  loadingSmevCheckHistory: false,
  smevCheckCarrierList: [],
  smevCheckSZLTList: [],
  smevCheckVehicleList: [],
  loadingCheckAllCarrier: false,
  loadingCheckAllSzlt: false,
  loadingCheckAllVehicles: false,
  loadingRegistrySmevCheckList: false,
  loadingImportVehicles: false,
  loadingImportCarrier: false,
  loadingImportSzlt: false,
  carrierExtractList: {},
  vehicleExtractList: {},
  szltExtractList: {},
  loadingCarrierExtractList: false,
  loadingVehicleExtractList: false,
  loadingSzltExtractList: false,
  carrierFieldsValidation: {},
  loadingCarrierFieldsValidation: false,
  vehicleFieldsValidation: {},
  loadingVehicleFieldsValidation: false,
  szltFieldsValidation: {},
  loadingSZLTFieldsValidation: false,
  relationCarrierVehicleListMeta: {},
  relationCarrierVehicleList: [],
  loadingRelationCarrierVehicleList: false,
  relationCarrierSzltListMeta: {},
  relationCarrierSzltList: [],
  loadingRelationCarrierSzltList: false,
  relationVehicleSzltListMeta: {},
  relationVehicleSzltList: [],
  loadingRelationVehicleSzltList: false,
  szltListModalMeta: {},
  loadingSzltListModal: false,
  szltListModal: [],
  carrierListModalMeta: {},
  loadingCarrierListModal: false,
  carrierListModal: [],
  vehiclesListModalMeta: {},
  loadingVehiclesListModal: false,
  vehiclesListModal: [],
  loadingImportOsago: false,
  loadingExportOsago: false,
  loadingVehicleRegistryBatchCommand: false,
  loadingCarrierRegistryBatchCommand: false,
  loadingSzltRegistryBatchCommand: false,
};

const reducer = handleActions({
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + BATCH_COMMAND_VEHICLE, 'loadingVehicleRegistryBatchCommand'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + BATCH_COMMAND_CARRIER, 'loadingCarrierRegistryBatchCommand'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + BATCH_COMMAND_SZLT, 'loadingSzltRegistryBatchCommand'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST, 'szltList', 'loadingSzltList'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL, 'szltListModal', 'loadingSzltListModal'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL, 'carrierListModal', 'loadingCarrierListModal'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL, 'vehiclesListModal', 'loadingVehiclesListModal'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + CREATE_SZLT, 'loadingCreateSZLT'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EDIT_SZLT_BY_ID, 'loadingEditSZLT'),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID, 'currentSZLT', 'loadingCurrentSZLT', {}),
  ...createLoadByIdReducer(REGION_REGISTRY_MODULE + ASSIGN_SZLT_BY_ID, 'currentSZLT', 'loadingCurrentSZLT'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ARCHIVE_SZLT, 'loadingArchiveSZLT'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + UNARCHIVE_SZLT, 'loadingUnarchiveSZLT'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + DELETE_SZLT, 'loadingDeleteSZLT'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ANNULMENT_SZLT, 'loadingAnnulmentSZLT'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST, 'carrierList', 'loadingCarrierList'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + CREATE_CARRIER, 'loadingCreateCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EDIT_CARRIER_BY_ID, 'loadingEditCarrier'),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID, 'currentCarrier', 'loadingCurrentCarrier', {}),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ARCHIVE_CARRIER, 'loadingArchiveCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + UNARCHIVE_CARRIER, 'loadingUnarchiveCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + DELETE_CARRIER, 'loadingDeleteCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ANNULMENT_CARRIER, 'loadingAnnulmentCarrier'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST, 'vehiclesList', 'loadingVehiclesList'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + CREATE_VEHICLES, 'loadingCreateVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EDIT_VEHICLES_BY_ID, 'loadingEditVehicles'),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID, 'currentVehicles', 'loadingCurrentVehicles', {}),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ARCHIVE_VEHICLES, 'loadingArchiveVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + UNARCHIVE_VEHICLES, 'loadingUnarchiveVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + DELETE_VEHICLES, 'loadingDeleteVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + ANNULMENT_VEHICLES, 'loadingAnnulmentVehicles'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST, 'registryHistoryList', 'loadingRegistryHistoryList'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST, 'registryExportList', 'loadingRegistryExportList'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST, 'registrySmevCheckList', 'loadingRegistrySmevCheckList'),

  ...createOperationStateReducer(REGION_REGISTRY_MODULE + IMPORT_CARRIER, 'loadingImportCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + IMPORT_VEHICLES, 'loadingImportVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + IMPORT_SZLT, 'loadingImportSzlt'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EXPORT_CARRIER, 'loadingExportCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EXPORT_VEHICLES, 'loadingExportVehicles'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EXPORT_SZLT, 'loadingExportSzlt'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + IMPORT_OSAGO, 'loadingImportOsago'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + EXPORT_OSAGO, 'loadingExportOsago'),

  ...createLoadListReducer(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_CARRIER_LIST, 'smevCheckCarrierList', 'loadingSmevCheckCarrierList'),
  ...createLoadListReducer(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_SZLT_LIST, 'smevCheckSZLTList', 'loadingSmevCheckSzltList'),
  ...createLoadListReducer(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_VEHICLE_LIST, 'smevCheckVehicleList', 'loadingSmevCheckVehicleList'),

  ...createOperationStateReducer(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_CARRIER, 'loadingCheckAllCarrier'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_SZLT, 'loadingCheckAllSzlt'),
  ...createOperationStateReducer(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_VEHICLES, 'loadingCheckAllVehicles'),

  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + EXTRACT_CARRIER, 'carrierExtractList', 'loadingCarrierExtractList', {}),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + EXTRACT_SZLT, 'szltExtractList', 'loadingSzltExtractList', {}),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES, 'vehicleExtractList', 'loadingVehicleExtractList', {}),

  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION, 'carrierFieldsValidation', 'loadingCarrierFieldsValidation', {}),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION, 'vehicleFieldsValidation', 'loadingVehicleFieldsValidation', {}),
  ...updateLoadParameterReducer(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION, 'szltFieldsValidation', 'loadingSZLTFieldsValidation', {}),

  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST, 'relationCarrierVehicleList', 'loadingRelationCarrierVehicleList'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST, 'relationCarrierSzltList', 'loadingRelationCarrierSzltList'),
  ...createLoadListReducerWithBegin(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST, 'relationVehicleSzltList', 'loadingRelationVehicleSzltList'),

}, initialState);

export default reducer;

export const getRegisterData = createSelector(
  [state => state[REGION_REGISTRY_MODULE]],
  state => {
    const {
      szltListMeta,
      loadingSzltList,
      szltList,
      loadingCreateSZLT,
      loadingEditSZLT,
      currentSZLT,
      loadingCurrentSZLT,
      loadingArchiveSZLT,
      loadingUnarchiveSZLT,
      loadingDeleteSZLT,
      loadingAnnulmentSZLT,
      carrierListMeta,
      loadingCarrierList,
      carrierList,
      loadingCreateCarrier,
      loadingEditCarrier,
      currentCarrier,
      loadingCurrentCarrier,
      loadingArchiveCarrier,
      loadingUnarchiveCarrier,
      loadingDeleteCarrier,
      loadingAnnulmentCarrier,
      vehiclesListMeta,
      loadingVehiclesList,
      vehiclesList,
      loadingCreateVehicles,
      loadingEditVehicles,
      currentVehicles,
      loadingCurrentVehicles,
      loadingArchiveVehicles,
      loadingUnarchiveVehicles,
      loadingDeleteVehicles,
      loadingAnnulmentVehicles,
      loadingRegistryHistoryList,
      registryHistoryList,
      registryHistoryListMeta,
      registryExportList,
      registryExportListMeta,
      loadingExportHistory,
      registrySmevCheckList,
      registrySmevCheckListMeta,
      loadingSmevCheckHistory,
      smevCheckCarrierList,
      smevCheckSZLTList,
      smevCheckVehicleList,
      loadingCheckAllCarrier,
      loadingCheckAllSzlt,
      loadingCheckAllVehicles,
      loadingRegistrySmevCheckList,
      loadingImportVehicles,
      loadingImportCarrier,
      loadingImportSzlt,
      loadingCarrierExtractList,
      loadingVehicleExtractList,
      loadingSzltExtractList,
      vehicleExtractList,
      szltExtractList,
      carrierExtractList,
      carrierFieldsValidation,
      loadingCarrierFieldsValidation,
      vehicleFieldsValidation,
      loadingVehicleFieldsValidation,
      szltFieldsValidation,
      loadingSZLTFieldsValidation,
      relationCarrierVehicleListMeta,
      relationCarrierVehicleList,
      loadingRelationCarrierVehicleList,
      relationCarrierSzltListMeta,
      relationCarrierSzltList,
      loadingRelationCarrierSzltList,
      relationVehicleSzltListMeta,
      relationVehicleSzltList,
      loadingVehicleSzltList,
      szltListModalMeta,
      loadingSzltListModal,
      szltListModal,
      carrierListModalMeta,
      loadingCarrierListModal,
      carrierListModal,
      vehiclesListModalMeta,
      loadingVehiclesListModal,
      vehiclesListModal,
      loadingImportOsago,
      loadingExportOsago,
      loadingRelationVehicleSzltList,
      loadingVehicleRegistryBatchCommand,
      loadingCarrierRegistryBatchCommand,
      loadingSzltRegistryBatchCommand,
      loadingExportCarrier,
      loadingExportVehicles,
      loadingExportSzlt,
    } = state;
    return {
      loadingVehicleRegistryBatchCommand,
      loadingCarrierRegistryBatchCommand,
      loadingSzltRegistryBatchCommand,
      loadingRelationVehicleSzltList,
      loadingImportOsago,
      loadingExportOsago,
      szltListModalMeta,
      loadingSzltListModal,
      szltListModal,
      carrierListModalMeta,
      loadingCarrierListModal,
      carrierListModal,
      vehiclesListModalMeta,
      loadingVehiclesListModal,
      vehiclesListModal,
      relationVehicleSzltListMeta,
      relationVehicleSzltList,
      loadingVehicleSzltList,
      relationCarrierVehicleListMeta,
      relationCarrierVehicleList,
      loadingRelationCarrierVehicleList,
      relationCarrierSzltListMeta,
      relationCarrierSzltList,
      loadingRelationCarrierSzltList,
      szltListMeta,
      loadingSzltList,
      szltList,
      loadingCreateSZLT,
      loadingEditSZLT,
      // currentSZLT: new SZLTDTO(currentSZLT).getData(),
      currentSZLT,
      loadingCurrentSZLT,
      loadingArchiveSZLT,
      loadingUnarchiveSZLT,
      loadingDeleteSZLT,
      loadingAnnulmentSZLT,
      carrierListMeta,
      loadingCarrierList,
      carrierList,
      loadingCreateCarrier,
      loadingEditCarrier,
      // currentCarrier: new CarrierDTO(currentSZLT).getData(),
      currentCarrier,
      loadingCurrentCarrier,
      loadingArchiveCarrier,
      loadingUnarchiveCarrier,
      loadingDeleteCarrier,
      loadingAnnulmentCarrier,
      vehiclesListMeta,
      loadingVehiclesList,
      vehiclesList,
      loadingCreateVehicles,
      loadingEditVehicles,
      currentVehicles,
      loadingCurrentVehicles,
      loadingArchiveVehicles,
      loadingUnarchiveVehicles,
      loadingDeleteVehicles,
      loadingAnnulmentVehicles,
      loadingRegistryHistoryList,
      registryHistoryList,
      registryHistoryListMeta,
      registryExportList,
      registryExportListMeta,
      loadingExportHistory,
      registrySmevCheckList,
      registrySmevCheckListMeta,
      loadingSmevCheckHistory,
      smevCheckCarrierList,
      smevCheckSZLTList,
      smevCheckVehicleList,
      loadingCheckAllCarrier,
      loadingCheckAllSzlt,
      loadingCheckAllVehicles,
      loadingRegistrySmevCheckList,
      loadingImportVehicles,
      loadingImportCarrier,
      loadingImportSzlt,
      loadingCarrierExtractList,
      loadingVehicleExtractList,
      loadingSzltExtractList,
      vehicleExtractList,
      szltExtractList,
      carrierExtractList,
      carrierFieldsValidation,
      loadingCarrierFieldsValidation,
      vehicleFieldsValidation,
      loadingVehicleFieldsValidation,
      szltFieldsValidation,
      loadingSZLTFieldsValidation,
      loadingExportCarrier,
      loadingExportVehicles,
      loadingExportSzlt,
    };
  },
);
